export function weekToDate(weekLabel) {
  let year = weekLabel.substring(0, 2)
  let weekNum = Number(weekLabel.substring(2))
  if (Number(year) < 50) {
    year = '19' + year
  } else {
    year = '20' + year
  }
  // 每年的第一天
  let yearFirstDay = new Date(year + '-01-01').getDay()
  let startDate
  if (yearFirstDay === 7) {
    startDate = new Date(year + '-01-01')
  } else {
    startDate = new Date(new Date(year + '-01-01').getFullYear() - 1 + '-12-31')
  }
  // 当年起始时间
  startDate = startDate.setDate(startDate.getDate() - yearFirstDay + 1)
  // 当前周起始时间
  startDate = startDate.setDate(startDate.getDate() + (weekNum - 1) * 7)
  let endDate = new Date(startDate.getTime())
  endDate.setDate(endDate.getDate() + weekNum * 7 - 1)
  return {
    startDate,
    endDate
  }
}
export function dateToWeek(date) {
  let timeStamp = date.getTime()
  let weeks = getWeeksByYear(date.getFullYear() + '')
  if (date.getMonth() > 10) {
    weeks = weeks.concat(getWeeksByYear(date.getFullYear() + 1 + ''))
  }
  for (let i = 0, len = weeks.length; i < len; i++) {
    let week = weeks[i]
    week.startDate.setHours(0, 0, 0)
    week.endDate.setHours(23, 59, 59)
    if (
      week.startDate.getTime() <= timeStamp &&
      week.endDate.getTime() >= timeStamp
    ) {
      return week.label
    }
  }
}

export function getWeeksByYear(year) {
  // 每年的第一天
  let yearFirstDay = new Date(year + '-01-01').getDay()
  let yearLabel = year.substring(2)
  let startDate

  if (yearFirstDay === 7) {
    startDate = new Date(year + '-01-01')
  } else {
    startDate = new Date(Number(year) - 1 + '-12-31')
    startDate = new Date(
      startDate.setDate(startDate.getDate() - yearFirstDay + 1)
    )
  }

  let result = [
    {
      startDate: new Date(startDate.getTime()),
      endDate: new Date(
        new Date(startDate.getTime()).setDate(startDate.getDate() + 6)
      ),
      label: yearLabel + '01'
    }
  ]
  for (let i = 1, len = 100; i < len; i++) {
    const range = result[i - 1]
    let weekStartDate = new Date(range.endDate.getTime())
    weekStartDate.setDate(range.endDate.getDate() + 1)
    let weekEndDate = new Date(range.endDate.getTime())
    weekEndDate.setDate(range.endDate.getDate() + 7)
    if (weekEndDate.getFullYear() + '' !== year) {
      break
    }
    result.push({
      startDate: weekStartDate,
      endDate: weekEndDate,
      label: yearLabel + (i > 8 ? i + 1 : '0' + (i + 1))
    })
  }
  return result
}
